module.exports = __webpack_public_path__ + "img/sd.18664904.svg";